import React from 'react';

const PVCTwoWayBallValveIcon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737',
  stemStartColor,
  stemMidColor,
  stemEndColor
}) => {
  const _stemStart = stemStartColor || startColor;
  const _stemMid = stemMidColor || midColor;
  const _stemEnd = stemEndColor || endColor;

  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 112.5 100.79"
      className={className}
    >

<g id={`${uid}_1`}>
	<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="46.7344" y1="13.8467" x2="65.6523" y2="13.8467">
		<stop offset="0" style={{stopColor: `${_stemStart}`}} />
		<stop offset="0.45" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.55" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.73" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.77" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="1" style={{stopColor: `${_stemStart}`}} />
	</linearGradient>
	<rect x="46.734" fill={`url(#${uid}_2)`} width="18.918" height="27.694" />
</g>
<g id={`${uid}_3`}>
	<linearGradient id={`${uid}_4`} gradientUnits="userSpaceOnUse" x1="24.6069" y1="23.3096" x2="24.6069" y2="2.3643">
		<stop offset="0" style={{stopColor: `${_stemStart}`}} />
		<stop offset="0.45" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.55" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.73" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.77" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="1" style={{stopColor: `${_stemStart}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_4)`} d="M0.001,2.364V23.31h48.084l1.126-1.126V3.49l-1.126-1.126H0.001z" />
</g>
<g id={`${uid}_5`}>
	<path fill={`${_stemEnd}`} d="M2.254,4.617v16.44h43.58l0.901-0.9V5.518l-0.901-0.9H2.254z" />
</g>
<g id={`${uid}_6`}>
	<linearGradient id={`${uid}_7`} gradientUnits="userSpaceOnUse" x1="8.5439" y1="93.8037" x2="8.5439" y2="56.0586">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<polyline fill={`url(#${uid}_7)`} points="17.088,93.804 0,93.804 0,56.059 16.953,56.059  " />
</g>
<g id={`${uid}_8`}>
	<linearGradient id={`${uid}_9`} gradientUnits="userSpaceOnUse" x1="103.1465" y1="93.8037" x2="103.1465" y2="56.0586">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<polyline fill={`url(#${uid}_9)`} points="93.794,56.059 112.498,56.059 112.498,93.804 93.941,93.804  " />
</g>
<g id={`${uid}_10`}>
	<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="56.0815" y1="100.7852" x2="56.0815" y2="49.2104">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<rect x="13.853" y="49.21" fill={`url(#${uid}_11)`} width="84.457" height="51.575" />
	<linearGradient id={`${uid}_12`} gradientUnits="userSpaceOnUse" x1="37.3877" y1="44.5688" x2="74.8867" y2="44.5688">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_12)`} d="M37.5,25.787V47.77c-0.071,0.474-0.113,0.953-0.113,1.44c0,7.368,8.595,14.141,18.918,14.141   s18.467-6.772,18.467-14.141h0.113V25.787H37.5z" />
</g>
    </svg>
  );
};

export default PVCTwoWayBallValveIcon;
